module.exports = __webpack_public_path__ + "static/cowboys-text_en.d623e14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cowboys-text_en.png
// module id = 425
// module chunks = 35783957827783